module.exports = __webpack_public_path__ + "static/media/early-warning-signs-large@2x.8f1c7b34.png";